import * as React from 'react';
import useStyles from './Lock.styles';

export interface ILockProps {}

const Lock: React.FC<ILockProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="13.4267"
          y="29.4733"
          width="36.7467"
          height="24.0267"
          rx="2.49412"
          fill="#D4F0FF"
        />
        <path
          d="M11.7484 25.4152H42.6651C44.76 25.4152 46.4582 27.1135 46.4582 29.2084V44.6667C46.4582 46.7616 44.76 48.4598 42.6651 48.4598H11.7484C9.6535 48.4598 7.95526 46.7616 7.95526 44.6667V29.2084C7.95526 27.1135 9.6535 25.4152 11.7484 25.4152Z"
          stroke="black"
          strokeOpacity="0.94"
          strokeWidth="1.24706"
        />
        <mask id="path-3-inside-1_107_393" fill="white">
          <path d="M16.1651 24.7917V15.9583C16.1651 13.0299 17.3284 10.2214 19.3991 8.15069C21.4698 6.07997 24.2783 4.91666 27.2067 4.91666C30.1352 4.91666 32.9437 6.07997 35.0144 8.15069C37.0851 10.2214 38.2484 13.0299 38.2484 15.9583V24.7917" />
        </mask>
        <path
          d="M16.1651 15.9583H14.918H16.1651ZM27.2067 4.91666V3.6696V4.91666ZM17.4121 24.7917V15.9583H14.918V24.7917H17.4121ZM17.4121 15.9583C17.4121 13.3606 18.4441 10.8693 20.2809 9.03249L18.5173 7.26888C16.2127 9.57347 14.918 12.6992 14.918 15.9583L17.4121 15.9583ZM20.2809 9.03249C22.1177 7.19564 24.609 6.16372 27.2067 6.16372V3.6696C23.9476 3.6696 20.8219 4.9643 18.5173 7.26888L20.2809 9.03249ZM27.2067 6.16372C29.8044 6.16372 32.2957 7.19564 34.1326 9.03249L35.8962 7.26888C33.5916 4.9643 30.4659 3.6696 27.2067 3.6696V6.16372ZM34.1326 9.03249C35.9694 10.8693 37.0013 13.3606 37.0013 15.9583H39.4955C39.4955 12.6992 38.2008 9.57347 35.8962 7.26888L34.1326 9.03249ZM37.0013 15.9583V24.7917H39.4955V15.9583H37.0013Z"
          fill="black"
          fillOpacity="0.94"
          mask="url(#path-3-inside-1_107_393)"
        />
        <circle cx="27.9134" cy="34.7734" r="3.88667" fill="#209AD6" />
        <rect
          x="26.1468"
          y="35.8334"
          width="3.53333"
          height="6.36"
          rx="1.76667"
          fill="#209AD6"
        />
      </svg>
    </div>
  );
};

export default Lock;
